import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  DiscoveryGetTrends200,
  DiscoveryGetTrendsParams,
  GetExploreContent200,
  GetExploreContentParams
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 트렌드 목록 조회
 */
export const discoveryGetTrends = (
    params?: DiscoveryGetTrendsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DiscoveryGetTrends200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/trends`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getDiscoveryGetTrendsQueryKey = (params?: DiscoveryGetTrendsParams,) => {
    return [`https://api.ugot.uk/api/trends`, ...(params ? [params]: [])] as const;
    }

    
export const getDiscoveryGetTrendsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof discoveryGetTrends>>, TError = AxiosError<unknown>>(params?: DiscoveryGetTrendsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscoveryGetTrendsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof discoveryGetTrends>>> = ({ signal }) => discoveryGetTrends(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData> & { queryKey: QueryKey }
}

export type DiscoveryGetTrendsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof discoveryGetTrends>>>
export type DiscoveryGetTrendsInfiniteQueryError = AxiosError<unknown>

/**
 * @summary 트렌드 목록 조회
 */
export const useDiscoveryGetTrendsInfinite = <TData = Awaited<ReturnType<typeof discoveryGetTrends>>, TError = AxiosError<unknown>>(
 params?: DiscoveryGetTrendsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDiscoveryGetTrendsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDiscoveryGetTrendsQueryOptions = <TData = Awaited<ReturnType<typeof discoveryGetTrends>>, TError = AxiosError<unknown>>(params?: DiscoveryGetTrendsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscoveryGetTrendsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof discoveryGetTrends>>> = ({ signal }) => discoveryGetTrends(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData> & { queryKey: QueryKey }
}

export type DiscoveryGetTrendsQueryResult = NonNullable<Awaited<ReturnType<typeof discoveryGetTrends>>>
export type DiscoveryGetTrendsQueryError = AxiosError<unknown>

/**
 * @summary 트렌드 목록 조회
 */
export const useDiscoveryGetTrends = <TData = Awaited<ReturnType<typeof discoveryGetTrends>>, TError = AxiosError<unknown>>(
 params?: DiscoveryGetTrendsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof discoveryGetTrends>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDiscoveryGetTrendsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 탐색 콘텐츠 조회
 */
export const getExploreContent = (
    params?: GetExploreContentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetExploreContent200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/explore`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetExploreContentQueryKey = (params?: GetExploreContentParams,) => {
    return [`https://api.ugot.uk/api/explore`, ...(params ? [params]: [])] as const;
    }

    
export const getGetExploreContentInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getExploreContent>>, TError = AxiosError<unknown>>(params?: GetExploreContentParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExploreContentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExploreContent>>> = ({ signal }) => getExploreContent(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExploreContentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getExploreContent>>>
export type GetExploreContentInfiniteQueryError = AxiosError<unknown>

/**
 * @summary 탐색 콘텐츠 조회
 */
export const useGetExploreContentInfinite = <TData = Awaited<ReturnType<typeof getExploreContent>>, TError = AxiosError<unknown>>(
 params?: GetExploreContentParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetExploreContentInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetExploreContentQueryOptions = <TData = Awaited<ReturnType<typeof getExploreContent>>, TError = AxiosError<unknown>>(params?: GetExploreContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExploreContentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExploreContent>>> = ({ signal }) => getExploreContent(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExploreContentQueryResult = NonNullable<Awaited<ReturnType<typeof getExploreContent>>>
export type GetExploreContentQueryError = AxiosError<unknown>

/**
 * @summary 탐색 콘텐츠 조회
 */
export const useGetExploreContent = <TData = Awaited<ReturnType<typeof getExploreContent>>, TError = AxiosError<unknown>>(
 params?: GetExploreContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExploreContent>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetExploreContentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



